import { loader } from 'graphql.macro'

export default async function deleteCommentOnTicket ({ dataLoaders, variables }) {
  const schema = loader('./deleteCommentOnTicket.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: {
      commentId: variables.commentId
    }
  })

  return response.deleteCommentOnTicket
}
